import { Pipe, PipeTransform } from '@angular/core';
//example:   <p class="text-14 text-333" [outerHTML]="post.content | highlightKeyword:['biden', 'mỹ']"></p>

@Pipe({ name: 'locationConverter' })
export class LocationConverterPipe implements PipeTransform {
  transform(street: string , province: string , country: string) {
    let result = [];
    if(street) {
        result.push(street)
    }
    if(province) {
        result.push(province)
    }
    if(country) {
        result.push(country)
    }
    return result.join(", ")
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_pipe/location.pipe.ts